import Routing from 'fos-routing';
// import file with routes data
const RoutingData =
  process.env.MODE && process.env.MODE == 'local'
    ? require('../router/fos_js_routes_export_default')
    : require('../router/fos_js_routes_export');
let routerDefault = RoutingData['default'];
// set data
Routing.setData(routerDefault);

// export library
export default Routing;



// WEBPACK FOOTER //
// ./src/core/router/router.js